@import "src/styles/common/_colors.scss";
.emptyReport {        
    display: flex;
    height: 100%;
    width: 100%;
    text-align: center;
    background-color: $mightnight-black;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
